import { DownOutlined } from "@ant-design/icons";
import { Collapse } from "antd";

const MarkupBookingBreakup = ({ markup_detail }) => {
  return (
    <>
      <p>Markup Details</p>
      <Collapse
        accordion
        expandIconPosition="end"
        className="border-none rounded-lg bg-bgbox"
        expandIcon={({ isActive }) => (
          <DownOutlined rotate={isActive ? 180 : 0} />
        )}
      >
        <Collapse.Panel
          className="border-none rounded-none"
          header={<HeaderTitle markup_detail={markup_detail} />}
          key={1}
        >
          {/* <div className="flex items-center justify-between px-4 py-2 bg-[#F3F3F3]">
            <div className="flex flex-col items-start gap-2 sm:w-1/2 md:w-1/2">
              <p className="text-sm">View Details</p>
            </div>
            <span></span>
          </div> */}
          {/* <div className="flex items-center justify-between px-4 py-2 bg-[#F3F3F3] gap-5">
            <span className="text-sm">
              Category {markup_detail?.customerCategory} = {markup_detail?.customerCatergoryPercentage}
            </span>
         
          </div>
          <div className="flex items-center justify-between px-4 py-2 bg-[#F3F3F3] gap-5">
            <span className="text-sm">
              ODCC Strategy ID = {markup_detail?.odccStrategyPercentage}
            </span>
          </div> */}
          <div className="flex items-center justify-between px-4 py-2 bg-[#F3F3F3] gap-5">
            <p>Markup = {markup_detail?.minMarkupPercentage}</p>
          </div>
        </Collapse.Panel>
      </Collapse>
    </>
  );
};

const HeaderTitle = ({ markup_detail }) => {
  return (
    <div className="flex items-center justify-between font-bold">
      {markup_detail?.carrier} = {markup_detail?.minMarkupPercentage} %
      <span className="text-sm">
             View details
            </span>
    </div>
  );
};

export default MarkupBookingBreakup;
